module.exports = __webpack_public_path__ + "img/India.a539ddf7.png";